// extracted by mini-css-extract-plugin
export default {"name":"ColleagueAccessTable_name__s80pd"};